import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { observer, inject } from 'mobx-react'
/* eslint-enable */

import styleB from '../../style'

import access from '../../../../utils/access'

import Container from '../partials/Container'
import ApplicationTable from '../partials/ApplicationTable'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Application', 'Community', 'User', 'Auth', 'Config')
@observer
export class Main extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        search: {
          input: '',
          active: false
        }
      }
    }
  }

  componentWillMount () {
    const _searchApplications = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending || this.props.User.me.pending) {
          return _searchApplications()
        }

        Promise.all([
          ...(access.adminCom(this.props.User.me.permissions)
            ? [this.props.Application.getAllApplications()]
            : []),
          this.props.Community.my.map(c =>
            this.props.Application.getApplication(c.id)
          )
        ]).then(() =>
          Promise.all(
            this.props.Application.all
              .slice()
              .map(
                a =>
                  this.props.Community.all.slice().find(c => c.id === a.comId)
                    ? Promise.resolve()
                    : this.props.Community.getCommunity(a.comId)
              )
          )
        )
      }, 500)
    }

    _searchApplications()
  }

  onItemClick (e) {
    e.preventDefault()
    const comId = e.currentTarget.dataset.comid

    if (!comId) {
      return
    }

    return this.props.history.push(`/dashboard/community/${comId}/application`)
  }

  onSearchInputChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        search: {
          ...this.state.editor.search,
          input: e.target.value
        }
      }
    })
  }

  onSearchClick () {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        search: {
          ...this.state.editor.search,
          active: true
        }
      }
    })
  }

  onAddClick (e) {
    e.preventDefault()
    return this.props.history.push(`${this.props.location.pathname}/new`)
  }

  onSearchSubmit (e) {
    e.preventDefault()

    console.log('search!!!!!!')
  }

  render () {
    return (
      <Container {...this.props}>
        <Row>
          <Col xs='12' lg='6'>
            <h2 className={css(styleB.headers.h2)}>Applications</h2>
          </Col>
          <Col
            style={{
              overflow: `hidden`,
              position: `relative`,
              transition: `0.2s`
            }}
          />
        </Row>
        <Row>
          <ApplicationTable
            theme={THEME_LIST[this.props.Config.theme]}
            communities={
              access.adminCom(this.props.User.me.permissions || {})
                ? this.props.Community.all.slice()
                : this.props.Community.my.slice()
            }
            applications={
              access.adminCom(this.props.User.me.permissions || {})
                ? this.props.Application.all.slice()
                : this.props.Application.my.slice()
            }
            onClick={this.onItemClick.bind(this)}
          />
        </Row>
      </Container>
    )
  }
}

export default Main



// WEBPACK FOOTER //
// ./src/components/Community/Main/Application/index.js